import { atomWithStorage } from '@capsicum/common';
import { atom } from 'jotai';
import { loadable } from 'jotai/utils';

import { type WCPledgeBasketItem } from '../../models';

export const wcPledgeBasketAtom = atomWithStorage<Array<WCPledgeBasketItem>>('wcPledgeBasket', []);
const loadableWcPledgeBasketAtom = loadable(wcPledgeBasketAtom);

export const wcPledgeBasketLoadingAtom = atom(get => {
	const basket = get(loadableWcPledgeBasketAtom);

	return basket.state === 'loading';
});

type WcPledgeBasketAggregate = {
	isEmpty: boolean;
	items: Array<WCPledgeBasketItem>;
	length: number;
	selectedTeamIds: Set<string>;
	totalPledgeAmount: number;
	totalUSDAmount: string;
};

const wcPledgeBasketAggregateAtom = atom<WcPledgeBasketAggregate>(get => {
	const loadableBasket = get(loadableWcPledgeBasketAtom);

	if (loadableBasket.state !== 'hasData') {
		return {
			isEmpty: true,
			items: [],
			length: 0,
			selectedTeamIds: new Set<string>(),
			totalPledgeAmount: 0,
			totalUSDAmount: '0.00'
		};
	}

	const items: Array<WCPledgeBasketItem> = loadableBasket.data;
	let total = 0;
	let totalUsd = 0;
	const selectedTeamIds = new Set<string>();

	for (const item of items) {
		total += item.amount;
		totalUsd += item.usdAmount;
		selectedTeamIds.add(item.teamId);
	}

	return {
		isEmpty: items.length === 0,
		items,
		length: items.length,
		selectedTeamIds,
		totalPledgeAmount: total,
		totalUSDAmount: totalUsd.toFixed(2)
	};
});

export const wcPledgeBasketDataAtom = atom(get => get(wcPledgeBasketAggregateAtom).items);
export const wcPledgeBasketLengthAtom = atom(get => get(wcPledgeBasketAggregateAtom).length);
export const isWCPledgeBasketEmptyAtom = atom(get => get(wcPledgeBasketAggregateAtom).isEmpty);
export const wcPledgeBasketSelectedTeamIdsAtom = atom(get => get(wcPledgeBasketAggregateAtom).selectedTeamIds);
export const wcPledgeBasketTotalPledgeAmountAtom = atom(get => get(wcPledgeBasketAggregateAtom).totalPledgeAmount);
export const wcPledgeBasketTotalUSDAmountAtom = atom(get => get(wcPledgeBasketAggregateAtom).totalUSDAmount);
